// @flow

import React from 'react';
import { H3 } from '../Typography';
import P from '../Typography/P';
import styles from './styles.module.scss';

type Props = {
  title: string,
  text: string,
  width?: string,
  height?: string,
  srcVideo?: string,
  id?: string,
  icon?: any,
  video?: boolean,
}

const CardContent = ({
  title, text, width = '100%', height = '100%', srcVideo, icon, video, id,
}: Props) => (
  <div className={styles.videoCardWrapper} key={id}>
    { video && (
      <iframe
        key={id}
        title="omaha"
        id={id}
        width={width}
        height={height}
        src={srcVideo}
        frameBorder="0"
        allowFullScreen
      />
    )}
    <div className={styles.videoTitle}>
      { icon && <img src={icon} alt={`${icon}`} /> }
      <H3>{title}</H3>
    </div>
    <div className={styles.videoDescr}><P size="bigger">{text}</P></div>
  </div>
);
// src="https://www.youtube.com/embed/yBLdQ1a4-JI?autoplay=1&origin=http://example.com"

export default CardContent;
